import InputNumber from './inputNumber.vue'

InputNumber.install = function(Vue) {
  Vue.component(InputNumber.name, InputNumber);
};

export default InputNumber;


// WEBPACK FOOTER //
// ./src/index.js